webpackJsonp([10],{

/***/ 5001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_theme__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Contact__ = __webpack_require__(5055);
var mapStateToProps=function mapStateToProps(state){return{theme:state.theme};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadTheme:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_2__actions_theme__["a" /* default */].fetch,dispatch)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__pages_Contact__["a" /* default */]));

/***/ }),

/***/ 5051:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMailtoLink = exports.toSearchString = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toSearchString = exports.toSearchString = function toSearchString() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(searchParams).map(function (key) {
    return key + '=' + encodeURIComponent(searchParams[key]);
  }).join('&');
};

var createMailtoLink = exports.createMailtoLink = function createMailtoLink(email, headers) {
  var link = 'mailto:' + email;
  if (headers) {
    link += '?' + toSearchString(headers);
  }
  return link;
};

var Mailto = function (_Component) {
  _inherits(Mailto, _Component);

  function Mailto() {
    _classCallCheck(this, Mailto);

    return _possibleConstructorReturn(this, (Mailto.__proto__ || Object.getPrototypeOf(Mailto)).apply(this, arguments));
  }

  _createClass(Mailto, [{
    key: 'render',
    value: function render() {
      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
    }
  }, {
    key: 'renderLink',
    value: function renderLink() {
      var _props = this.props,
          email = _props.email,
          obfuscate = _props.obfuscate,
          headers = _props.headers,
          children = _props.children,
          others = _objectWithoutProperties(_props, ['email', 'obfuscate', 'headers', 'children']);

      return _react2.default.createElement(
        'a',
        _extends({ href: createMailtoLink(email, headers) }, others),
        children
      );
    }
  }, {
    key: 'renderObfuscatedLink',
    value: function renderObfuscatedLink() {
      var _props2 = this.props,
          email = _props2.email,
          obfuscate = _props2.obfuscate,
          headers = _props2.headers,
          children = _props2.children,
          others = _objectWithoutProperties(_props2, ['email', 'obfuscate', 'headers', 'children']);

      return _react2.default.createElement(
        'a',
        _extends({ onClick: this.handleClick.bind(this), href: 'mailto:obfuscated' }, others),
        children
      );
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      var _props3 = this.props,
          email = _props3.email,
          headers = _props3.headers;

      window.location.href = createMailtoLink(email, headers);
    }
  }]);

  return Mailto;
}(_react.Component);

Mailto.propTypes = {
  children: _propTypes2.default.node.isRequired,
  email: _propTypes2.default.string.isRequired,
  headers: _propTypes2.default.object,
  obfuscate: _propTypes2.default.bool
};

Mailto.defaultProps = {
  obfuscate: false
};

exports.default = Mailto;


/***/ }),

/***/ 5055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_mailto__ = __webpack_require__(5051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_mailto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_mailto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_io_social_twitter_outline__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_io_social_twitter_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_io_social_twitter_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_io_social_instagram_outline__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_io_social_instagram_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_io_social_instagram_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_io_ios_email_outline__ = __webpack_require__(5056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_io_ios_email_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_io_ios_email_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Animated__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Sad from 'react-icons/lib/io/sad-outline';
var squareGrid=Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])({display:'inline-flex',justifyContent:'center',alignItems:'center',height:'25vw','@media(max-width: 48em)':{height:'50vw'}});var button=Object.assign({},__WEBPACK_IMPORTED_MODULE_8__styles__["t" /* shadowless */],__WEBPACK_IMPORTED_MODULE_8__styles__["m" /* quarterWidth */],__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* fullWidthSm */],squareGrid);var Contact=function(_Component){_inherits(Contact,_Component);function Contact(){_classCallCheck(this,Contact);return _possibleConstructorReturn(this,(Contact.__proto__||Object.getPrototypeOf(Contact)).apply(this,arguments));}_createClass(Contact,[{key:'componentWillMount',value:function componentWillMount(){this.props.loadTheme();}},{key:'render',value:function render(){var colors=this.props.theme.colors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,{title:'Contact lucastswick',description:'Use lucastswick\'s contact details to reach him in times of emergency. Or just to say hi.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_8__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Animated__["a" /* default */],{as:'h1'},'Contact Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Animated__["a" /* default */],null,'If you live in Portland, I\'m always down to grab a coffee! DM me on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({},__WEBPACK_IMPORTED_MODULE_8__styles__["t" /* shadowless */],{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://twitter.com/lucastswick'}),'twitter'),' ','and we\'ll make it happen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_8__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_mailto___default.a,Object.assign({email:'lucas@generativeartist.com',obfuscate:true},button,Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])({background:colors[1],color:'white'}),{target:'_blank'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_io_ios_email_outline___default.a,{color:'white',size:90}),'Email me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({},button,Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])({background:colors[2],color:'white'}),{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://twitter.com/lucastswick'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_io_social_twitter_outline___default.a,{color:'white',size:90}),'Tweet at me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({},button,Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])({background:colors[3],color:'white'}),{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://instagram.com/lucastswick'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_io_social_instagram_outline___default.a,{color:'white',size:90}),'Instaboodle'))));}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),

/***/ 5056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(2061);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosEmailOutline = function IoIosEmailOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 10h30v20h-30v-20z m15 10.9l12.7-9.6h-25.4z m-13.7 7.9h27.5v-16.8l-9 6.9 5.3 6-0.2 0.2-6.2-5.5-3.7 2.9-3.7-2.9-6.2 5.5-0.2-0.2 5.3-6-8.9-6.9v16.8z' })
        )
    );
};

exports.default = IoIosEmailOutline;
module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.a797d6c8.chunk.js